export default __webpack_public_path__ + "static/loyalty-scams-533eef186cc48cedd2a0ad771ad4b022.webp";